<template>
	<div class="guide_container">
		<div class="guide_layout">
			<div class="guide_layout_item">
				<div class="country_tab">
					<ConnectedSquareTab
						:items="[...COUNTRY_TABS]"
						:selected-item="selectedCountryTab"
						@update:detail-tab="onChangeCountryTab"
					/>
				</div>

				<!-- 한국 탭(기존 마크업 유지) -->
				<template v-if="selectedCountryTab === '한국'">
					<div class="guide_layout_item_header">
						<span class="primary_color"> 대가의선택 서비스 살펴보기 </span>
						<div class="category">
							<span>무료</span>
							<span class="primary">구독</span>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span> 투자대가들의 <strong>매매전략&노하우</strong> </span>
						<div class="content">
							<div>
								<CheckIcon />
							</div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span>투자대가 7인 <strong>포트폴리오</strong> (한국)</span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span>투자대가 7인 <strong>종목 분석 리포트</strong> (한국)</span>
						<div class="content">
							<div>일부</div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<div class="hot_item">
							<span>맞춤 전략 <strong>HOT 랭킹 검색기</strong></span>
							<div class="c_tag color-primary"><img src="@/assets/img/common/hot_rank.png" alt="HOT" />HOT</div>
						</div>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span> 한눈에 보는 <strong>마켓 타이밍</strong> (한국)</span>
						<div class="content">
							<div>
								<CheckIcon />
							</div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span> 한눈에 보는 <strong>업종 타이밍</strong> </span>
						<div class="content">
							<div>
								<CheckIcon />
							</div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span> 실전매매 <strong>노하우 공유</strong> </span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span> 산업/기업 <strong>분석 리포트</strong> (매월)</span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span> 한국 증시 <strong>업종 지도</strong> </span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span>구독자 대상 할인 <strong>대가 MALL</strong> </span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span>나만의 <strong>관심종목</strong> </span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span>대가의 종목 <strong>기업 분석 리포트</strong> </span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content last">
						<div class="hot_item">
							<span><strong>구독 전용 실시간 텔레그램</strong></span>
							<div class="c_tag color-primary"><img src="@/assets/img/common/hot_rank.png" alt="HOT" />HOT</div>
						</div>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
				</template>

				<!-- 미국 탭 -->
				<template v-if="selectedCountryTab === '미국'">
					<div class="guide_layout_item_header">
						<span class="primary_color"> 미국 주식 </span>
						<div class="category">
							<span>무료</span>
							<span class="primary">구독</span>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<div class="hot_item">
							<span>
								투자대가 7인
								<strong>포트폴리오 (미국)</strong>
							</span>
							<div class="c_tag color-primary"><img src="@/assets/img/common/hot_rank.png" alt="HOT" />HOT</div>
						</div>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span>시가총액 TOP 500 <strong>기업 분석 리포트</strong></span>
						<div class="content">
							<div>일부</div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span> 한눈에 보는 <strong>마켓 타이밍</strong> (미국)</span>
						<div class="content">
							<div>
								<CheckIcon />
							</div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span> 상승률 상위 <strong>업종&테마 랭킹</strong></span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span><strong>업종&테마별 종목 분류</strong></span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span><strong>ETF</strong> 기초&핵심 정보</span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span>큰 손들의 실제 보유<strong> 포트폴리오</strong></span>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content last"></div>
				</template>

				<!-- 일본 탭 -->
				<template v-else-if="selectedCountryTab === '일본'">
					<div class="guide_layout_item_header">
						<span class="primary_color"> 일본 주식 </span>
						<div class="category">
							<span>무료</span>
							<span class="primary">구독</span>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<div class="hot_item">
							<span> 투자대가 7인 <strong>포트폴리오 (일본)</strong> </span>
							<div class="c_tag color-primary"><img src="@/assets/img/common/hot_rank.png" alt="HOT" />HOT</div>
						</div>
						<div class="content">
							<div></div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content">
						<span>시가총액 TOP 200 <strong>기업 분석 리포트</strong></span>
						<div class="content">
							<div>일부</div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
					<div class="guide_layout_item_content last">
						<span> 한눈에 보는 <strong>마켓 타이밍</strong> (일본)</span>
						<div class="content">
							<div>
								<CheckIcon />
							</div>
							<div class="primary">
								<CheckIcon />
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
		<div class="popup_action">
			<button class="c_button mid" @click="onClickGuide">서비스 안내</button>
			<!-- // 구독 버튼 임시 주석 261023
			<button class="c_button primary-fill" @click="onClickSubscribe">구독하기</button>
			-->
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import CheckIcon from '@/assets/img/common/smallCheck.svg?component';
import ConnectedSquareTab from '@/components/atom/tabBar/ConnectedSquareTab.vue';
import { useHeaderStore } from '@/stores/header';
import { useModalStore } from '@/stores/modal';

const router = useRouter();
const modalStore = useModalStore();
const headerStore = useHeaderStore();

const onClickGuide = () => {
	modalStore.closeModal('GuideModal');
	router.push('/notice-detail/188');
	// router.push('/notice-detail/159');
	// router.push('/notice-detail/90');
};
// 구독 버튼 임시 주석 261023
// const onClickSubscribe = () => {
// 	modalStore.closeModal('GuideModal');
// 	router.push('/payment');
// };

const COUNTRY_TABS = ['한국', '미국', '일본'] as const;
type CountryTab = (typeof COUNTRY_TABS)[number];

const selectedCountryTab = ref<CountryTab>(
	headerStore.getCountry === 'USA' ? '미국' : headerStore.getCountry === 'JPN' ? '일본' : '한국'
);

const onChangeCountryTab = (tab: string) => {
	// ConnectedSquareTab의 emit 타입이 string이라, 여기서만 안전하게 좁혀서 사용
	const isCountryTab = (COUNTRY_TABS as readonly string[]).includes(tab);
	if (!isCountryTab) return;
	selectedCountryTab.value = tab as CountryTab;
};
</script>

<style lang="scss" scoped>
.guide_container {
	display: flex;
	flex-direction: column;
	gap: 2.4rem;

	min-width: 32rem; // 320px
}
::-webkit-scrollbar {
	width: 0.4rem;
	height: 17.6rem;
}
::-webkit-scrollbar-track {
	background: var(--color-bg);
}
::-webkit-scrollbar-thumb {
	background: var(--color-base-mid);
}
::-webkit-scrollbar-thumb:hover {
	background: #bbb;
}
.guide_layout {
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	max-width: 30.3rem;
	width: 100%;
	overflow-y: scroll;
	height: 40rem;

	.guide_layout_item {
		display: flex;
		flex-direction: column;
		padding-right: 0.4rem;
		.country_tab {
			position: sticky;
			top: 0;
			z-index: 2;
			padding: 0.8rem 0;
			background: var(--color-bg-mid);
			border-bottom: 1px solid var(--color-base-mid-dark);
			margin-bottom: 1.2rem;
		}
		&_header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			align-self: stretch;
			width: 100%;
			border-bottom: 1px solid var(--color-base-mid-dark);
			font-size: var(--font-s-small);
			font-weight: var(--font-w-semi-bold);
			.category {
				display: flex;
				gap: 0.8rem;
				span {
					padding: 1.2rem 0rem;
					width: 3.4rem;
					text-align: center;
				}
			}
		}

		&_content {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			align-self: stretch;
			width: 100%;
			font-size: var(--font-s-small);
			font-weight: var(--font-w-light);
			color: var(--color-base-light);
			border-bottom: 1px solid var(--color-base-mid-dark);
			strong {
				font-weight: var(--font-w-semi-bold);
				color: var(--color-base-white);
			}
			span {
				text-align: center;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
			}
			.content {
				display: flex;
				align-items: center;
				gap: 0.8rem;
				div {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 3.4rem;
					height: 3.2rem;
				}
				div.extend {
					height: 5.6rem;
				}
				span {
					padding: 1.2rem 0rem;
					width: 3.4rem;
					text-align: center;
				}
			}
		}
	}
}
.popup_action {
	display: flex;
	gap: 0.8rem;
	button {
		height: 5.2rem;
		padding: 1.3rem 1.6rem;
		border-radius: 0.6rem;
		width: 100%;
	}
}

.guide_layout .guide_layout_item_content .open {
	max-width: 11.8rem;
	width: 100%;
	justify-content: center;
	align-items: center;
	height: 3.2rem;
	text-align: center;
}
.guide_layout .guide_layout_item_content span.flex-start {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.guide_layout_item_content {
	.hot_item {
		display: flex;
		align-items: center;
		gap: 0.4rem;

		.c_tag {
			display: flex;
			align-items: center;

			color: var(--color-font-white);

			img {
				width: 1.6rem;
				height: 1.6rem;
				filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.2)); // 아이콘 경계 명확화
			}
		}
	}
}

.guide_layout .last {
	border-bottom: none;
}
.primary {
	background-color: var(--color-primary);
}
.primary_color {
	color: var(--color-secondary);
}
.danger_text {
	color: var(--color-danger);
}
</style>
